import { OnDestroy, Directive } from '@angular/core';
import { UtilitiesDate } from '../services/utilities.date';
import { UtilitiesPrimeNG } from '../services/utilities.primeng';
import { Subscription } from 'rxjs';

@Directive()
export abstract class BaseComponent implements OnDestroy {

    utilitiesDate = UtilitiesDate;

    utilitiesPrimeNG = UtilitiesPrimeNG

    subscriptions: Subscription[] = [];

    ngOnDestroy(): void {}


}
